import bugsnag from '@bugsnag/js'

const bugsnagKey = process.env.VUE_APP_BUGSNAG_KEY
const releaseStage = process.env.VUE_APP_ENV

const bugsnagClient = bugsnag({
  apiKey: bugsnagKey,
  releaseStage: releaseStage || 'development',
  notifyReleaseStages: ['staging', 'production'],
})

export default bugsnagClient
